/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newsletter_Card_Privacy_NoteInputs */

const en_newsletter_card_privacy_note = /** @type {(inputs: Newsletter_Card_Privacy_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No spam. One click to unsubscribe, any time.`)
};

/**
* | output |
* | --- |
* | "No spam. One click to unsubscribe, any time." |
*
* @param {Newsletter_Card_Privacy_NoteInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const newsletter_card_privacy_note = /** @type {((inputs?: Newsletter_Card_Privacy_NoteInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newsletter_Card_Privacy_NoteInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_newsletter_card_privacy_note(inputs)
});